/* eslint-disable @typescript-eslint/no-explicit-any */
import { Box, Typography } from '@mui/material';
import { DataGrid } from '@mui/x-data-grid';
import React, { useState } from 'react';
import { fonts, themes } from '../../../../common/themes/themes';
import { useAppSelector } from '../../../../infra/hooks';
import SearchComponent from '../../../../common/components/SearchComponent';
import ActionButton from '../../../../common/components/ActionButtons/ActionButton';
import EmpTrainingDetailsModalController from '../../../../common/Modals/Training/EmpTrainingDetails/EmpTrainingDetailsModalController';
import MarkasCompleteController from '../../../../common/Modals/Training/MarkasComplete/MarkasCompleteController';
import EditMarkasCompleteController from '../../../../common/Modals/Training/EditMarkasComplete/EditMarkasCompleteController';
import ViewCompTrainingController from '../../../../common/Modals/Training/ViewCompletedTraining/ViewCompTrainingController';
import _ from 'lodash';
import { check_user_permission } from '../../../../common/configs/utils';
import { DateField } from '../../../../components';
import {
  baseDateFormatting,
  baseTimeFormatting,
} from '../../../../common/helper';

interface propMyTraining {
  trans?: any;
  i18n?: any;
  trainingData: any;
  setAcceptStatus: any;
}
const EmpTrainingPresenter: React.FC<propMyTraining> = ({
  trainingData,
  setAcceptStatus,
  trans,
}) => {
  const auth_permissions = useAppSelector(
    (state: any) => state.authPermissionSlice?.authPermission,
  );
  const [pageSize, setPageSize] = React.useState<number>(10);
  const [empTrainingDetails, showEmpTrainingDetails] = useState(false);
  const [markasComplete, showMarkasComplete] = useState(false);
  const [editMarkasComplete, showEditMarkasComplete] = useState(false);
  const [viewCompTraining, showViewCompTraining] = useState(false);
  const [traineesData, setTraineesData] = useState([]);
  const [editTraineesData, setEditTraineesData] = useState([]);
  const [viewScheduled, setViewScheduled] = useState([]);
  const [textFiltertraining, setTextFiltertraining] = useState('');

  const handleAccepStatus = (status: any, id: any) => {
    setAcceptStatus(status, id);
  };

  const handleMarkasComplete = (data: any) => {
    setTraineesData(data);
    showMarkasComplete(true);
  };

  const handleEditMarkasComplete = (data: any) => {
    setEditTraineesData(data);
    showEditMarkasComplete(true);
  };

  const handleViewCompletedTraining = (data: any) => {
    setEditTraineesData(data);
    showViewCompTraining(true);
  };

  const handleViewScheduled = (data: any) => {
    setViewScheduled(data);
    showEmpTrainingDetails(true);
  };

  const filtertrainingList = () => {
    if (textFiltertraining.length) {
      const txt = textFiltertraining.toLowerCase();
      const res = _.filter(trainingData, function (e) {
        return e?.trainingtype.toLowerCase().includes(txt);
      });

      return res;
    } else {
      return trainingData;
    }
  };

  const tableColumns: any = [
    {
      field: 'trainingtype',
      headerName: trans('Training Type'),
      width: 160,
      headerClassName: 'header',
      height: 70,
      flex: 1,
    },
    {
      field: 'timezone',
      headerName: trans('timezone'),
      width: 250,
      headerClassName: 'header',
      height: 90,
      flex: 2,
      renderCell: (params: any) => {
        return params.row?.timezone?.timezone;
      },
    },
    {
      field: 'startdate',
      headerName: trans('Start Date'),
      width: 100,
      headerClassName: 'header',
      height: 70,
      flex: 1,
      renderCell: (params: any) => {
        return (
          <DateField
            value={params.row.startdate}
            format={baseDateFormatting}
            offset={params?.row.timezone.offset}
          />
        );
      },
    },
    {
      field: 'enddate',
      headerName: trans('End Date'),
      width: 100,
      headerClassName: 'header',
      height: 70,
      flex: 1,
      renderCell: (params: any) => {
        return (
          <DateField
            value={params.row.enddate}
            format={baseDateFormatting}
            offset={params?.row.timezone.offset}
          />
        );
      },
    },
    {
      field: 'starttime',
      headerName: trans('Start Time'),
      width: 100,
      headerClassName: 'header',
      height: 70,
      flex: 1,
      renderCell: (params: any) => {
        return (
          <DateField
            value={params.row.starttime}
            format={baseTimeFormatting}
            offset={params?.row.timezone.offset}
          />
        );
      },
    },
    {
      field: 'endtime',
      headerName: trans('End Time'),
      width: 100,
      headerClassName: 'header',
      height: 70,
      flex: 1,
      renderCell: (params: any) => {
        return (
          <DateField
            value={params.row.endtime}
            format={baseTimeFormatting}
            offset={params?.row.timezone.offset}
          />
        );
      },
    },
    {
      field: 'status',
      headerName: trans('Status'),
      width: 140,
      headerClassName: 'header',
      height: 70,
      flex: 1,
      renderCell: (params: any) => {
        return params?.row?.status == 'Scheduled' ? (
          <Typography
            style={{
              color: themes.yellow,
              fontFamily: fonts.fontFamily,
              fontSize: fonts.subtitle,
              textTransform: 'capitalize',
            }}
          >
            {trans(params?.row?.status)}
          </Typography>
        ) : params?.row?.status == 'Accepted' ? (
          <Typography
            style={{
              color: themes.green,
              fontFamily: fonts.fontFamily,
              fontSize: fonts.subtitle,
              textTransform: 'capitalize',
            }}
          >
            {trans(params?.row?.status)}
          </Typography>
        ) : params?.row?.status == 'Completed' ? (
          <Typography
            style={{
              color: '#0C2372',
              fontFamily: fonts.fontFamily,
              fontSize: fonts.subtitle,
              textTransform: 'capitalize',
            }}
          >
            {trans(params?.row?.status)}
          </Typography>
        ) : params?.row?.status == 'Canceled' ? (
          <Typography
            style={{
              color: themes.red,
              fontFamily: fonts.fontFamily,
              fontSize: fonts.subtitle,
              textTransform: 'capitalize',
            }}
          >
            {trans(params?.row?.status)}
          </Typography>
        ) : (
          ''
        );
      },
    },
    {
      field: 'action',
      flex: 1,
      headerName: trans('Action'),
      headerClassName: 'header',
      width: 140,
      height: 70,
      renderCell: (params: any) => {
        console.log('params---', params?.row?.action);
        return params?.row?.status == 'Scheduled' ? (
          <ActionButton
            elements={['true', 'false', 'view']}
            True={() => handleAccepStatus(2, params?.row?.id)}
            View={() => handleViewScheduled(params?.row?.action)}
            False={() => handleAccepStatus(4, params?.row?.id)}
          />
        ) : params?.row?.status == 'Accepted' ? (
          <ActionButton
            elements={['mark']}
            Mark={() => handleMarkasComplete(params?.row?.action)}
          />
        ) : params?.row?.status == 'Completed' ? (
          <ActionButton
            elements={['edit', 'view']}
            Edit={() => handleEditMarkasComplete(params?.row?.action)}
            View={() => handleViewCompletedTraining(params?.row?.action)}
          />
        ) : (
          ''
        );
      },
    },
  ];

  const handleGetTextFilter = (value: any) => {
    setTextFiltertraining(value);
  };

  return (
    <>
      <SearchComponent onChange={handleGetTextFilter} />
      <Box style={{ maxHeight: '30em', overflowY: 'auto' }}>
        <DataGrid
          sx={{
            fontSize: fonts.subtitle,
            color: '#081735',
            fontFamily: fonts.fontFamily,
            marginTop: '1.5em',
          }}
          autoHeight
          disableColumnFilter
          disableColumnMenu
          pageSize={pageSize}
          onPageSizeChange={(newPageSize) => setPageSize(newPageSize)}
          rowsPerPageOptions={[10]}
          // pageSize={30}
          disableSelectionOnClick
          rows={filtertrainingList()}
          columns={check_user_permission(
            auth_permissions,
            tableColumns,
            'action_menu',
          )}
        />
      </Box>
      {empTrainingDetails && (
        <EmpTrainingDetailsModalController
          isModalOpen={empTrainingDetails}
          closeModal={() => showEmpTrainingDetails(false)}
          viewScheduled={viewScheduled}
        />
      )}
      {markasComplete && (
        <MarkasCompleteController
          isModalOpen={markasComplete}
          closeModal={() => showMarkasComplete(false)}
          traineesData={traineesData}
        />
      )}
      {editMarkasComplete && (
        <EditMarkasCompleteController
          isModalOpen={editMarkasComplete}
          closeModal={() => showEditMarkasComplete(false)}
          editTraineesData={editTraineesData}
        />
      )}
      {viewCompTraining && (
        <ViewCompTrainingController
          isModalOpen={viewCompTraining}
          closeModal={() => showViewCompTraining(false)}
          editTraineesData={editTraineesData}
        />
      )}
    </>
  );
};
export default EmpTrainingPresenter;
